import { SUMMARY_VIEW } from '@/fixtures'

export default {
  path: 'bup-summary',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Summary',
      component: () => import('@/views/menus/SummaryBUP/Index'),
      meta: {
        permission: SUMMARY_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Summary',
      component: () => import('@/views/menus/SummaryBUP/View'),
      meta: {
        permission: SUMMARY_VIEW
      }
    },
    {
      path: 'list-summary-hm-ewh',
      name: 'List Summary HM & EWH',
      component: () => import('@/views/menus/SummaryBUP/ListSummaryHM'),
      meta: {
        permission: SUMMARY_VIEW
      }
    }
  ]
}
